var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-table-simple",
    { attrs: { small: true, "sticky-header": "" } },
    [
      _c(
        "b-thead",
        [
          _c(
            "b-tr",
            [
              _c(
                "b-th",
                {
                  staticStyle: {
                    "text-align": "left",
                    "vertical-align": "middle",
                    width: "20%",
                  },
                },
                [_vm._v("Change Type")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: {
                    "text-align": "left",
                    "vertical-align": "middle",
                    width: "20%",
                  },
                },
                [_vm._v("Column")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: {
                    "text-align": "left",
                    "vertical-align": "middle",
                    width: "20%",
                  },
                },
                [_vm._v("Field")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: {
                    "text-align": "left",
                    "vertical-align": "middle",
                    width: "20%",
                  },
                },
                [_vm._v("Old")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: {
                    "text-align": "left",
                    "vertical-align": "middle",
                    width: "20%",
                  },
                },
                [_vm._v("New")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-tbody",
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "b-tr",
            [
              _c("b-td", [_vm._v(_vm._s(item.change_type))]),
              _c("b-td", [_vm._v(_vm._s(item.column))]),
              _c("b-td", [_vm._v(_vm._s(item.field))]),
              _c("b-td", [_vm._v(_vm._s(item.old))]),
              _c("b-td", [_vm._v(_vm._s(item.new))]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }